import Styles from "./style.module.scss";
import { useEffect, useRef } from "react";
import UseOutsideClick from "@Hooks/useOutsideClick";
import DoneGif from "../../../../../assets/Gifs/done.gif"

export default function RecruiterDoneModal({
  handleDone = () => { },
  title,
  description,
  showButton,
  titleButton,
  show
}) {
  const boxRef = useRef();
  const boxOutsideClick = UseOutsideClick(boxRef);

  useEffect(() => {
    if (show) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.removeProperty('overflow')
    }
  }, [show])


  useEffect(() => {
    if (boxOutsideClick) {
      handleDone();
    }
  }, [boxOutsideClick, handleDone]);

  useEffect(() => {
    if (!showButton) {
      setTimeout(function () {
        handleDone();
      }, 3000);
    }
  }, [showButton, handleDone]);

  return (
    <div className={Styles.background}>
      <div className={Styles.container} ref={boxRef}>
        <img src={DoneGif} style={{ width: '202px', aspectRatio: 1, objectFit: 'cover' }} alt="" />
        <h4>{title}</h4>
        <p>{description}</p>
        {showButton && (
          <button onClick={handleDone}>{titleButton || "Tutup"}</button>
        )}
      </div>
    </div>
  );
}
